import { useEffect, createContext, type PropsWithChildren, useCallback, useState } from 'react';

import axios from 'axios';
import { useContainer } from 'unstated-next';

import AdminAuthContainer from './AdminAuthContainer';
import { GET_USER_PROFILE_DATA } from '../../config/apiPaths';
import { getUrls } from '../../utils/url';

export interface ProfileProviderProps {
    profileId: string | null;
    onBack?: () => void;
    narrowStyle?: boolean;
    fullScreen?: boolean;
}

interface ProfileContextInterface {
    profileId: string | null;
    loading: boolean;
    isNarrowStyle: boolean;
    isFullScreen: boolean;
    errorMessage: string;
    errorModalMessage: string;
    setErrorModalMessage: (message: string) => void;
    openErrorModal: boolean;
    setOpenErrorModal: (openEditModal: boolean) => void;
    profileData: any;
    onBack?: () => void;
    meFetched: boolean;
}

const ProfileContext = createContext(undefined as unknown as ProfileContextInterface);

const { Provider, Consumer } = ProfileContext;

const ProfileProvider = (props: PropsWithChildren<ProfileProviderProps>) => {
    const { uuid, authMode, showDemoContent } = useContainer(AdminAuthContainer);
    const { fullScreen, narrowStyle, profileId, children } = props;
    const [isLoading, setIsLoading] = useState(true);
    const [profileData, setProfileData] = useState<any>({ loading: true, profileData: {} });
    const [openErrorModal, setOpenErrorModal] = useState<boolean>(false);
    const [errorModalMessage, setErrorModalMessage] = useState<string>('');
    const [errorMessage, setErrorMessage] = useState<string>('');
    const [meFetched, setMeFetched] = useState<boolean>(false);
    const { api } = getUrls();

    console.log('profileProvider profileId', profileId);

    const fetchProfileData = useCallback(async () => {
        try {
            // should get extra data not base data
            const { data } = await axios.get(
                `${api}${GET_USER_PROFILE_DATA}?user_uuid=${uuid}&user_id=${profileId}&auth_mode=${authMode}&demo_content=${showDemoContent}`
            );
            console.log('profile data', data);
            setProfileData(data);
            setIsLoading(false);
        } catch (err) {
            setErrorMessage(err!.toString());
            setProfileData(undefined);
            setIsLoading(false);
        }
    }, [api, uuid, profileId, authMode, showDemoContent]);

    useEffect(() => {
        const fetchMe = async () => {
            fetchProfileData();
            setMeFetched(true);
        };

        fetchMe();
    }, [api, fetchProfileData, authMode, showDemoContent]);

    return (
        <Provider
            value={{
                profileId,
                loading: profileData.loading || isLoading,
                isFullScreen: !!fullScreen,
                isNarrowStyle: !!narrowStyle,
                openErrorModal,
                setOpenErrorModal,
                errorModalMessage,
                setErrorModalMessage,
                profileData,
                meFetched,
                errorMessage
            }}
        >
            {children}
        </Provider>
    );
};

export { ProfileContext, ProfileProvider, Consumer as ProfileConsumer };
